export default {
    data() {
        return {
            categoryId: ''
        };
    },
    methods: {
        changeCategory(categoryId, categoryTitle) {
            this.categoryId = categoryId;
            this.$emit('changedCategoryId', this.categoryId);
            if (!categoryId || !categoryTitle) return;
            this.triggerEventGA('click_category', {
                id: categoryId,
                title: categoryTitle
            });
        }
    }
};